import type { FetchPackageCategoriesListQuery } from '@/features/package-categories/api'
import type { PackageCategoriesSearch } from '@/routes/_protected/$tenantKey/settings/package-categories/-models'

export function buildFetchPackageCategoriesQuery(
  tenantKey: string,
  deps: PackageCategoriesSearch
): FetchPackageCategoriesListQuery {
  return {
    tenantKey,
    query: {
      ...deps
    }
  }
}
